// Libs
import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { Form } from 'react-bootstrap';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import SubAgencyService from 'services/SubAgencyService';
import TextHelpers from 'helpers/TextHelpers';

// Components
import Loader from 'components/common/Loader';
import PageHeader from 'components/common/PageHeader';

// Images
import silhouetteImage from 'images/sub-agency-silhouette.png';

//-------------------------------------------------------------------------------------------------------------------

class InstructorListPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            query: '',
            subAgencies: [],
            allSubAgencies: []
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.load();
    }

    async load() {
        this.setState({ isLoading: true });
        const allSubAgencies = await SubAgencyService.list();
        allSubAgencies.forEach(i => {
            i.searchString = TextHelpers.simplifySearchString(i.name);
        });
        GlobalStateService.setValues({
            area: 'sub-agencies'
        });
        this.setState({
            allSubAgencies,
            subAgencies: this.getFiltered(allSubAgencies),
            isLoading: false
        });
    }

    search(query) {
        this.setState({
            query,
        }, () =>
            this.debounceFilter()
        );
    }

    debounceFilter() {
        clearTimeout(this.filterTimeout);
        this.filterTimeout = setTimeout(() => {
            this.setState({
                subAgencies: this.getFiltered(this.state.allSubAgencies)
            });
        }, 100);
    }

    getFiltered(allSubAgencies) {
        const query = TextHelpers.simplifySearchString(this.state.query);
        const queryParts = query.split(' ');
        const subAgencies = allSubAgencies.filter(i => queryParts.every(qp => i.searchString.indexOf(qp) != -1));
        return subAgencies;
    }

    render() {
        return (
            <div className="page sub-agency-list-page">

                <PageHeader>
                    <h1>Sub-agencies</h1>

                    <div className="buttons">

                        <Link to="/sub-agency/new" className="btn btn-primary">
                            <span className="fa-solid fa-plus"></span>{' '}
                            New sub-agency
                        </Link>

                    </div>
                </PageHeader>

                <main>

                    <Container>
                        
                        <section className="search">
                            <input
                                type="search"
                                autoFocus
                                placeholder={`Search for sub-agency...`}
                                onChange={e => this.search(e.target.value)}
                            />
                            <span className="icon fa-solid fa-search" />
                        </section>
                        
                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>
        );
    }

    renderInner() {
        const {
            isLoading,
            subAgencies
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        if (subAgencies.length == 0) {
            return (
                <div className="empty-text">
                    Sorry, no sub-agencies matched your criteria
                </div>
            );
        }

        return (
            <ul className="thing-list">
                {subAgencies.map(subAgency =>
                    <li key={subAgency.id} >

                        <Link to={`/sub-agency/${subAgency.slug}`}>
                            
                            <div className="profile-image" style={{
                                backgroundImage: (
                                    subAgency.photoVersion ? `url(/api/sub-agency/get-photo/${subAgency.id}?size=small&version=${subAgency.photoVersion})` :
                                        `url(${silhouetteImage})`
                                )
                            }} />

                            <div className="details">
                                <h3>
                                    {subAgency.name}
                                    {/*<div className="tags">
                                        TODO
                                        <span className="tag deactivated">
                                            <span className="tag-icon fa-solid fa-skull-crossbones" />
                                            <span className="tag-text">Deactivated</span>
                                        </span>
                                    </div>*/}
                                </h3>
                                <p className="detail">
                                    {subAgency.numInstructors} instructor{subAgency.numInstructors == 1 ? '' : 's'},{' '}
                                    {subAgency.numManagers} manager{subAgency.numManagers == 1 ? '' : 's'}
                                </p>
                            </div>

                        </Link>

                    </li>
                )}
            </ul>
        );
    }

    renderSideBarContent() {
        return (<>

            <Form.Group className="mb-3">
                <Form.Label>Instructor status</Form.Label>
                <Form.Check label="Standard" checked />
                <Form.Check label="Champion" checked />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Active status</Form.Label>
                {/*<Form.Control type="email" placeholder="Enter email" />*/}
                <Form.Check label="Active" checked />
                <Form.Check label="Inactive" checked />
                <Form.Check label="Potential" checked />
                <Form.Check label="Deactivated" />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Available to teach...</Form.Label>
                <Form.Check label="ILT" checked />
                <Form.Check label="vILT" checked />
            </Form.Group>

            <Form.Group>
                <Form.Label>Priority status</Form.Label>
                <Form.Check label="Priority" checked />
                <Form.Check label="Non-Priority" checked />
            </Form.Group>

        </>);
    }
}

export default withRouter(InstructorListPage);